const template = require('./eft_request_list.html.slim');
const controller = require('./eft_request_list_controller');

angular.module('wbComponents').directive('eftRequestList', () =>
  ({
    restrict: 'E',
    controller,
    controllerAs: 'ctrl',
    bindToController: true,
    replace: true,
    templateUrl: template,
    scope: false
  })
);
